import { LocalizedPageTitle, PortfolioLayout, PortfolioLayoutHeader } from '@mews-commander/ui';
import {
    EnumFilterType,
    Table,
    TableActiveColumnFilters,
    TableHeader,
    TableProvider,
    useFullRowSelection,
} from '@optimus-web/core';
import { LocalizedText, useUrlSyncedTableState } from '@mews/framework';
import { PortfolioRateOverview, PortfolioRateOverviewFilters, PortfolioRateType } from '@mews-commander/data-access';
import { TextKey } from '@mews-commander/enums';
import { WithGuideLink } from '@mews-commander/types';
import { useRates } from '../../../queries';
import { UploadButton } from '../../sections/components';
import { columns } from './columns';
import { BulkActions } from './BulkActions';

export const RatesTable: React.FC<WithGuideLink> = ({ guideLink }) => {
    const [tableState, setTableState] = useUrlSyncedTableState<PortfolioRateOverview, PortfolioRateOverviewFilters>({
        columns,
        pageSize: 50,
    });

    const rateFilters: PortfolioRateOverviewFilters = {
        type: [{ filterType: EnumFilterType.In, value: [PortfolioRateType.Private, PortfolioRateType.Public] }],
    };
    const { data, isFetching } = useRates(tableState, rateFilters);
    const { selectedRowsData, rowSelection, setRowSelection, resetRowSelection } = useFullRowSelection(data?.data);

    return (
        <PortfolioLayout>
            <PortfolioLayoutHeader
                title={<LocalizedPageTitle textKey={TextKey.RatePlural} />}
                guideLink={guideLink}
                rightSide={<UploadButton />}
            />
            <TableProvider columns={columns} state={tableState} onStateChange={setTableState} as="div">
                <TableHeader
                    title={<LocalizedText textKey={TextKey.RatePlural} />}
                    subTitle={data?.totalRowCount || '0'}
                />
                <TableActiveColumnFilters />
                <BulkActions selectedRows={selectedRowsData} resetRowSelection={resetRowSelection} />
                <Table
                    uniqueRowId="id"
                    data={data?.data ?? []}
                    amountOfRows={data?.totalRowCount ?? 0}
                    loading={isFetching}
                    rowSelection={{
                        rowSelection,
                        onRowSelectionChange: setRowSelection,
                    }}
                    fixedFirstColumn
                    fixedLastColumn
                />
            </TableProvider>
        </PortfolioLayout>
    );
};
